import React from 'react';
import TextInput from '@/Shared/TextInput';
import DateInput from '@/Shared/DateInput';
import CustomCheckbox from '@/Shared/CustomCheckbox';
import ImageInput from '@/Shared/ImageInput';

const BannerForm = ({errors, data, setData}) => {
  return (
    <div className='flex flex-wrap p-8 -mb-8 -mr-6'>
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Link"
        name="url"
        type="text"
        errors={errors.url}
        value={data.url}
        onChange={e => setData('url', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Banner Name"
        name="banner_name"
        type="text"
        errors={errors.banner_name}
        value={data.banner_name}
        onChange={e => setData('banner_name', e.target.value)}
      />
      <DateInput
        date={data.expire_date}
        setDate={setData}
        valueName={'expire_date'}
        label={'Expiration Date'}
        errors={errors.expire_date}
      />
      <CustomCheckbox
        className="w-full pb-8 pr-6"
        label="Show Online"
        name="showonline"
        errors={errors.showonline}
        checked={data.showonline}
        onChange={e => setData('showonline', !!e.target.checked)}
      />
      <ImageInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Main Image"
        name="image"
        errors={errors.image}
        value={data.image}
        onChange={image => setData('image', image)}
      />
      <ImageInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Mobile Image"
        name="mob_image"
        errors={errors.mob_image}
        value={data.mob_image}
        onChange={mob_image => setData('mob_image', mob_image)}
      />
    </div>
  );
};

export default BannerForm;
